import type { Components } from '@mui/material/styles';

export default function MUITableFooter(): Components['MuiTableFooter'] {
  return {};
}
